module.exports = __webpack_public_path__ + "assets/b0bb70e609540824bed9571e399b0c5e.mp3";